import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import CategoryDropdown from "@/components/feature/CategoryDropdown";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import CategoryGrid from "./components/CategoryGrid";
import GuideCards from "./components/GuideCards";
import ArticlesSection from "./components/ArticlesSection";
import SafetyNote from "./components/SafetyNote";
import FAQ from "./components/FAQ";
import FinalCTA from "./components/FinalCTA";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Header />
      <main className="flex-1">
        <Hero />
        <Stats />

        {/* Category dropdown */}
        <section className="w-full bg-background-50">
          <div className="mx-auto max-w-6xl px-4 md:px-6 py-8">
            <CategoryDropdown />
          </div>
        </section>

        <CategoryGrid />
        <GuideCards />
        <ArticlesSection />
        <SafetyNote />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}